import {
  FULFILLMENT_STATUSES,
  IntegrationService,
  ORDER_METHODS,
  ORDER_PAYMENT_STATUSES,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../../services/exports/Constants';
import { action_create_dummy_order, action_launch_orders_portal_app } from '../../../../../../views/sales/orders';

export default {
  title: 'Tilaukset',
  buttons: {
    actions: 'Toiminnot',
    [action_create_dummy_order]: 'Luo testitilaus',
    [action_launch_orders_portal_app]: 'Käynnistä orders portal',
    show_order_details: 'Näytä tilauksen tiedot',
    track_order: 'Seuraa tilausta',
    update_dropoff_time: 'Päivitä toimitusaika',
    download_receipt: 'Lataa kuitti',
    open_payment_page: 'Avaa maksusivu',
  },
  form: {
    customer_details: {
      placeholder: 'Anna asiakkaan nimi tai puhelinnumero',
    },
    amount_min: {
      placeholder: 'Vähimmäismäärä',
    },
    amount_max: {
      placeholder: 'Enimmäismäärä',
    },
    utm_source: {
      placeholder: 'Anna UTM-lähde',
    },
    utm_medium: {
      placeholder: 'Anna UTM-media',
    },
    utm_campaign: {
      placeholder: 'Anna UTM-kampanja',
    },
    utm_advertisement_id: {
      placeholder: 'Anna UTM-mainostunnus',
    },
  },
  labels: {
    no_orders: 'Ei vielä tilauksia',
    total_orders: 'Tilauksia yhteensä',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Nouto',
    [ORDER_METHODS.delivery]: 'Toimitus',
    [ORDER_METHODS.room_service]: {
      [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Huonepalvelu',
      [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Pöytäpalvelu',
    },
  },
  payment_statuses: {
    [ORDER_PAYMENT_STATUSES.pending]: 'Odottaa',
    [ORDER_PAYMENT_STATUSES.paid]: 'Maksettu',
    [ORDER_PAYMENT_STATUSES.partially_refunded]: 'Osittain hyvitetty',
    [ORDER_PAYMENT_STATUSES.refunded]: 'Hyvitetty',
  },
  fulfillment_statuses: {
    default: {
      [FULFILLMENT_STATUSES.created]: 'Odottaa hyväksyntää',
      [FULFILLMENT_STATUSES.reviewed]: 'Odottaa hyväksyntää',
      [FULFILLMENT_STATUSES.accepted]: 'Käsittelyssä',
      [FULFILLMENT_STATUSES.preparing]: 'Käsittelyssä',
      [FULFILLMENT_STATUSES.ready]: 'Käsittelyssä',
      [FULFILLMENT_STATUSES.on_delivery]: 'Käsittelyssä',
      [FULFILLMENT_STATUSES.picked]: 'Valmis',
      [FULFILLMENT_STATUSES.rejected]: 'Hylätty',
      null: 'Tuntematon',
      undefined: 'Tuntematon',
    },
  },
  tags: {
    dummy: 'TESTI',
    pickup: 'Nouto',
    internal_delivery: 'Sisäinen toimitus',
    external_delivery: 'Ulkoinen toimitus',
    room_service: 'Huonepalvelu',
    table_service: 'Pöytäpalvelu',
    scheduled: 'Ajastettu',
    reward: 'Palkinto',
    mobile: 'Mobiili',
    invoice: 'Lasku',
    cash: 'Käteinen',
    rejected_automatically: 'Hylätty automaattisesti',
    rejected_manually: 'Hylätty manuaalisesti',
    call_center: 'Puhelinpalvelu',
    [IntegrationService.WinOrder]: 'WINORDER',
    [IntegrationService.ExpertOrder]: 'EXPERT ORDER',
    [IntegrationService.Deliverect]: 'DELIVERECT',
  },
  fields: {
    id: 'ID',
    company: 'Ravintola',
    tags: 'Tunnisteet',
    order_placed: 'Tilaus tehty',
    ready_at: 'Tilaus valmis',
    customer: 'Asiakas',
    items: 'Tuotteet',
    method: 'Menetelmä',
    payment_status: 'Maksun tila',
    fulfillment_status: 'Tila',
    total: 'Yhteensä',
    utm_source: 'UTM-lähde',
    utm_medium: 'UTM-media',
    utm_campaign: 'UTM-kampanja',
    utm_advertisement_id: 'UTM-mainostunnus',
  },
  metrics: {
    total_orders: 'Tilauksia yhteensä',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_create_dummy_order: 'Testitilauksen luominen epäonnistui',
    dummy_order_created: 'Testitilaus luotiin',
    failed_to_launch_orders_portal_app: 'Orders portalin käynnistäminen epäonnistui',
    failed_to_download_receipt: 'Kuitin lataaminen epäonnistui',
  },
};
